import { cn } from '@heidi/utils';

import type { ToastTone, ToastVariant } from './toast.types';

/**
 * DS-1202 experimental Toast tone classes: semantic tones consume the
 * reworked tiers — solid fills from `toast-background-*` (component tier),
 * outline surfaces from `semantic-*` (incl. the text role). Neutral/tier tones
 * are unchanged copies. Behind `release-experimental-design-system-forms`.
 */
export const solidToneClassesExperimental: Record<ToastTone, string> = {
  default: cn('border-background-primary bg-background-primary text-text-primary-invert'),
  subtle: cn('border-background-secondary bg-background-secondary text-text-primary'),
  destructive: cn(
    'border-toast-background-destructive bg-toast-background-destructive text-text-primary-invert'
  ),
  success: cn(
    'border-toast-background-success bg-toast-background-success text-text-primary-invert'
  ),
  pro: cn('border-tier-pro bg-tier-pro text-text-primary-invert'),
  practice: cn('border-tier-practice bg-tier-practice text-text-primary-invert'),
  warning: cn(
    'border-toast-background-warning bg-toast-background-warning text-text-primary-invert'
  ),
};

export const outlineToneClassesExperimental: Record<ToastTone, string> = {
  default: cn('border-outline bg-surface text-text-primary'),
  subtle: cn('border-outline bg-surface-accent text-text-primary'),
  success: cn(
    'border-semantic-border-success bg-semantic-background-success text-semantic-text-success'
  ),
  destructive: cn(
    'border-semantic-border-destructive bg-semantic-background-destructive text-semantic-text-destructive'
  ),
  warning: cn(
    'border-semantic-border-warning bg-semantic-background-warning text-semantic-text-warning'
  ),
  pro: cn('border-tier-pro-border bg-tier-pro-muted text-tier-pro-text'),
  practice: cn(
    'border-tier-practice-border bg-tier-practice-muted text-tier-practice-text'
  ),
};

export const getToastToneClassesExperimental = (
  variant: ToastVariant = 'outline',
  tone: ToastTone = 'default'
): string => {
  if (variant === 'solid') {
    return solidToneClassesExperimental[tone];
  }
  return outlineToneClassesExperimental[tone];
};
